import { ColumnDef } from '@tanstack/react-table';
import AdvanceTable from 'components/base/AdvanceTable';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import { MovimientoDeCaja } from 'data/project-management/movimientoDeCaja';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import ActionDropdownItems from 'components/common/ActionDropdownItems';
import { NavLink } from 'react-router-dom';
import { formatMoney } from 'helpers/utils';

// Define columns for MovimientoDeCaja
export const getCajaListTableColumns = (isGeneral: boolean, hideSaldo: boolean = false): ColumnDef<MovimientoDeCaja>[] => {
  return [
  {
    accessorKey: 'id',
    header: 'Caja ID',
    meta: {
      cellProps: { className: 'white-space-nowrap py-4' },
      headerProps: { style: { width: '5%' } }
    }
  },
  {
    accessorKey: 'created_at',
    header: 'Fecha',
    cell: ({ row: { original } }: { row: { original: MovimientoDeCaja } }) =>
        original.created_at
          ? new Date(original.created_at).toLocaleDateString('es-AR')
          : 'N/A',
    meta: {
      cellProps: { className: 'white-space-nowrap py-4' },
      headerProps: { style: { width: '5%' } }
    }
  },
  {
    accessorKey: 'pagos_fk',
    header: 'Pago',
    cell: ({ row: { original } }: { row: { original: MovimientoDeCaja } }) => (
        <NavLink
          to={`/app/apps/pagos/createpago/${original.pagos_fk}`}
        >
        {original.pagos_fk}
      </NavLink>
    ),
    meta: {
      cellProps: { className: 'white-space-nowrap py-4' },
      headerProps: { style: { width: '5%' } }
    }
  },
  {
    accessorKey: 'cobros_fk',
    header: 'Cobro',
    cell: ({ row: { original } }: { row: { original: MovimientoDeCaja } }) => (
        <NavLink
          to={`/app/apps/cobros/movimiento-details/${original.cobros_fk}`}
        >
        {original.cobros_fk}
      </NavLink>
    ),
    meta: {
      cellProps: { className: 'white-space-nowrap py-4' },
      headerProps: { style: { width: '5%' } }
    }
  },
  {
    accessorKey: 'usuario',
    header: 'Usuario',
    meta: {
      cellProps: { className: 'white-space-nowrap py-4' },
      headerProps: { style: { width: '5%' } }
    }
  },
  isGeneral && {
    accessorKey: 'caja',
    header: 'Caja Origen',
    cell: ({ row: { original } }: { row: { original: MovimientoDeCaja } }) => (
        <span >
          {original.caja?.toUpperCase() || '-'}
        </span>
      ),
    meta: {
      cellProps: { className: 'white-space-nowrap py-4' },
      headerProps: { style: { width: '5%' } }
    }
  },
  {
    accessorKey: 'movimiento',
    header: 'Movimiento',
    meta: {
      // LE QUITAMOS el 'white-space-nowrap' para que el texto baje de línea
      cellProps: { className: 'py-4' },
      headerProps: { style: { width: '20%' } }
    }
  },
  {
    accessorKey: 'Notas',
    header: 'Notas',
    meta: {
      // LE QUITAMOS el 'white-space-nowrap' para que el texto baje de línea
      cellProps: { className: 'py-4' },
      headerProps: { style: { width: '20%' } }
    }
  },
  {
    accessorKey: 'monto',
    header: 'Monto',
    cell: ({ row: { original } }: { row: { original: MovimientoDeCaja } }) =>
        original.monto != null
          ? `${original.monto.toLocaleString('es-AR', {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2
          })}`
        : '$0,00',
    meta: {
      cellProps: { className: 'white-space-nowrap py-4 text-end' },
      headerProps: { style: { width: '10%' }, className: 'text-end' } 
    }
  },
  !hideSaldo && 
  {
    accessorKey: 'saldo',
    header: 'Saldo',
    cell: ({ row: { original } }: { row: { original: MovimientoDeCaja } }) =>
        original.saldo != null
          ? `${original.saldo.toLocaleString('es-AR', {
              minimumFractionDigits: 0,
            maximumFractionDigits: 2
          })}`
        : '$0,00',
    meta: {
      cellProps: { className: 'white-space-nowrap py-4 text-end' },
      headerProps: { style: { width: '10%' }, className: 'text-end' } 
    }
  }
].filter(Boolean) as ColumnDef<MovimientoDeCaja>[];
};

const CajaListTable = () => {
  return (
    // Agregamos 'table-responsive' para asegurar que el contenedor maneje bien los anchos
    <div className="border-bottom border-translucent table-responsive">
      <AdvanceTable
        tableProps={{
          className: 'phoenix-table border-top border-translucent fs-9'
        }}
      />
      <AdvanceTableFooter pagination className="py-3" />
    </div>
  );
};

export default CajaListTable;